// ============================================================
// FORGEIQ — ENGINEERING RULES ENGINE v2.1
// Generated from analysis of 60+ production drawings
// Sturdfix / Singhania International Limited, Ludhiana
// ============================================================

// ---- MACHINE CONSTANTS ----

export const MACHINES = {
  // BOLT FORMERS
  SJBF_63S:  { id:'SJBF_63S',  name:'Sijin 63S',   type:'BOLT', stations:3, force_kg:38000,  wire_min:3,  wire_max:6,   shank_max:65,  die_case_od:null, die_len:null, ko_pin_len:null, punch_case_od:null, punch_case_len:null, cbf:'—',    qty:2, status:'ACTIVE' },
  SJBF_64S:  { id:'SJBF_64S',  name:'SJBF-64S',    type:'BOLT', stations:4, force_kg:40000,  wire_min:3,  wire_max:6,   shank_max:75,  die_case_od:null, die_len:null, ko_pin_len:null, punch_case_od:null, punch_case_len:null, cbf:'—',    qty:2, status:'ACTIVE' },
  DBF_84S:   { id:'DBF_84S',   name:'DBF-84S',     type:'BOLT', stations:4, force_kg:60000,  wire_min:5,  wire_max:8,   shank_max:90,  die_case_od:null, die_len:null, ko_pin_len:null, punch_case_od:null, punch_case_len:null, cbf:'—',    qty:2, status:'ACTIVE' },
  SJBF_134L: { id:'SJBF_134L', name:'SJBF-134L',   type:'BOLT', stations:4, force_kg:120000, wire_min:8,  wire_max:12.7,shank_max:152, die_case_od:86.0, die_len:190,  ko_pin_len:215,  punch_case_od:60.0, punch_case_len:130,  cbf:'CBF-04,05', qty:2, status:'ACTIVE' },
  DBF_134L:  { id:'DBF_134L',  name:'DBF-134L',    type:'BOLT', stations:4, force_kg:120000, wire_min:8,  wire_max:12.7,shank_max:160, die_case_od:86.0, die_len:190,  ko_pin_len:215,  punch_case_od:60.0, punch_case_len:130,  cbf:'—',    qty:1, status:'ACTIVE' },
  SJBF_164S: { id:'SJBF_164S', name:'SJBF-164S',   type:'BOLT', stations:4, force_kg:210000, wire_min:10, wire_max:16,  shank_max:152, die_case_od:90.0, die_len:190,  ko_pin_len:215,  punch_case_od:74.98,punch_case_len:185,  cbf:'CBF-03', qty:1, status:'ACTIVE' },
  // NUT FORMERS
  SN_11B6S:  { id:'SN_11B6S',  name:'11B6S Sijin',  type:'NUT',  stations:6, force_kg:55000,  wire_min:3,  wire_max:6,   shank_max:null, nut_size:'M3–M6',  af_min:5.5,  af_max:12.7, ko_pin_len:85,  punch_len:60,  punch_working_len:25, die_height_mm:18, die_taper_deg:6,  finger_len:35,  finger_body_od:10.18, finger_tail_taper:20, finger_width:5.05, finger_thickness:null, qty:2, status:'ACTIVE' },
  SN_14B6S:  { id:'SN_14B6S',  name:'14B6S Sijin',  type:'NUT',  stations:6, force_kg:85000,  wire_min:6,  wire_max:10,  shank_max:null, nut_size:'M6–M10', af_min:10,   af_max:17,   ko_pin_len:110, punch_len:70,  punch_working_len:25, die_height_mm:25, die_taper_deg:5,  finger_len:81,  finger_body_od:12.85, finger_tail_taper:20, finger_width:9,    finger_thickness:2.5, qty:2, status:'ACTIVE' },
  SN_19B6S:  { id:'SN_19B6S',  name:'19B6S Sijin',  type:'NUT',  stations:6, force_kg:130000, wire_min:8,  wire_max:14,  shank_max:null, nut_size:'M8–M14', af_min:14,   af_max:22,   ko_pin_len:130, punch_len:85,  punch_working_len:25, die_height_mm:22, die_taper_deg:5,  finger_len:100, finger_body_od:16.875,finger_tail_taper:20, finger_width:10,   finger_thickness:8,   qty:2, status:'ACTIVE' },
  SN_24B6S:  { id:'SN_24B6S',  name:'24B6S Sijin',  type:'NUT',  stations:6, force_kg:220000, wire_min:10, wire_max:18,  shank_max:null, nut_size:'M10–M18',af_min:17,   af_max:26,   ko_pin_len:170, punch_len:105, punch_working_len:20, die_height_mm:27, die_taper_deg:5,  finger_len:120, finger_body_od:14.0,  finger_tail_taper:20, finger_width:15,   finger_thickness:2,   qty:1, status:'ACTIVE' },
};

export type MachineId = keyof typeof MACHINES;

// ---- PART TEMPLATES ----

export type TemplateId = 'A' | 'A_EXT' | 'B' | 'B_S' | 'C' | 'D1' | 'D2' | 'D3' | 'D4' | 'D5' | 'D6';

export interface Template {
  id: TemplateId;
  name: string;
  family: 'BOLT' | 'NUT';
  stations: number;
  description: string;
  triggers: string[];
  machine_type: 'BOLT' | 'NUT';
}

export const TEMPLATES: Record<TemplateId, Template> = {
  A:     { id:'A',     name:'Long bolt',              family:'BOLT', stations:4, machine_type:'BOLT', description:'L/D > 4.0, has shank, head present', triggers:['L/D > 4.0','has_shank = true','head_type: socket or hex or flange'] },
  A_EXT: { id:'A_EXT', name:'Long bolt (external hex)',family:'BOLT', stations:4, machine_type:'BOLT', description:'Template A but external hex head', triggers:['L/D > 4.0','head_type: EXTERNAL_HEX','socket_type: NONE'] },
  B:     { id:'B',     name:'Short flange/plug',       family:'BOLT', stations:4, machine_type:'BOLT', description:'L/D < 3.5, flange or plug head', triggers:['L/D < 3.5','head_type: FLANGE or PLUG'] },
  B_S:   { id:'B_S',   name:'Short flange + serration',family:'BOLT', stations:4, machine_type:'BOLT', description:'Template B with serration on flange underface', triggers:['L/D < 3.5','head has serration','36 ribs standard M10'] },
  C:     { id:'C',     name:'Headless set screw',       family:'BOLT', stations:2, machine_type:'BOLT', description:'head_type = NONE, hex socket, M6–M16', triggers:['head_type = NONE','socket_type = HEX_SOCKET','requires stripper mechanism'] },
  D1:    { id:'D1',    name:'Serrated flange nut',      family:'NUT',  stations:6, machine_type:'NUT',  description:'Nut with flange and serration on underface', triggers:['part_type = NUT','has_flange = true','has_serration = true'] },
  D2:    { id:'D2',    name:'Plain hex nut',            family:'NUT',  stations:6, machine_type:'NUT',  description:'Standard hex nut, no flange', triggers:['part_type = NUT','has_flange = false','nut_type = PLAIN_HEX','hex forms at Stn 2'] },
  D3:    { id:'D3',    name:'Nylock / Flange Nylock',   family:'NUT',  stations:6, machine_type:'NUT',  description:'Nut with nylon insert pocket', triggers:['part_type = NUT','has_nylon_insert = true','dual sleeve stations 4+5'] },
  D4:    { id:'D4',    name:'Heavy hex nut',            family:'NUT',  stations:6, machine_type:'NUT',  description:'ASME B18.2.2 heavy hex, EN8D material, inch system', triggers:['part_type = NUT','standard = ASME B18.2.2','material = EN8D or A194 2H'] },
  D5:    { id:'D5',    name:'Conical washer nut',       family:'NUT',  stations:6, machine_type:'NUT',  description:'Hex nut with conical washer seat on underside', triggers:['part_type = NUT','has_conical_washer = true','EXT punch Stns 2+4'] },
  D6:    { id:'D6',    name:'Spinning nut (socket)',    family:'NUT',  stations:6, machine_type:'NUT',  description:'Nut with integrated socket/washer feature', triggers:['part_type = NUT','has_socket_feature = true','EXT punch dominant'] },
};

// ---- MATERIALS LIBRARY ----

export interface Material {
  id: string;
  name: string;
  grade: string;
  sigma_0_mpa: number;
  k_mpa: number;
  n: number;
  density: number;
  application: string;
  ht_quench_c?: string;
  ht_temper_c?: string;
  target_hrc?: string;
}

export const MATERIALS: Record<string, Material> = {
  '10B30': { id:'10B30', name:'10B30 Boron Steel', grade:'10.9', sigma_0_mpa:450, k_mpa:1050, n:0.19, density:7.85, application:'High-strength bolts, studs' },
  '10B33': { id:'10B33', name:'10B33 Boron Steel', grade:'10.9', sigma_0_mpa:480, k_mpa:1100, n:0.18, density:7.85, application:'High-strength bolts, higher boron' },
  '10B21': { id:'10B21', name:'10B21',              grade:'10.9', sigma_0_mpa:380, k_mpa:900,  n:0.21, density:7.85, application:'Bolts, lower C, more ductile' },
  '15B25': { id:'15B25', name:'15B25 Boron Steel', grade:'8.8',  sigma_0_mpa:280, k_mpa:720,  n:0.23, density:7.85, application:'Grade 8.8 hex bolts', ht_quench_c:'870–880', ht_temper_c:'450–530', target_hrc:'23–32' },
  'SAE1008':{ id:'SAE1008',name:'SAE 1008',         grade:'5.8',  sigma_0_mpa:180, k_mpa:560,  n:0.26, density:7.85, application:'Drain plugs, low-strength fasteners' },
  'SAE1010':{ id:'SAE1010',name:'SAE 1010',         grade:'5.8',  sigma_0_mpa:200, k_mpa:580,  n:0.25, density:7.85, application:'General fasteners Grade 5.8, Nylock nuts' },
  'SAE1022':{ id:'SAE1022',name:'SAE 1022',         grade:'8.8',  sigma_0_mpa:320, k_mpa:780,  n:0.22, density:7.85, application:'Medium-strength fasteners' },
  'SAE1035':{ id:'SAE1035',name:'SAE 1035',         grade:'8.8',  sigma_0_mpa:380, k_mpa:850,  n:0.20, density:7.85, application:'Medium-high strength' },
  'SCM435': { id:'SCM435', name:'SCM-435 (SAE 4135)',grade:'—',   sigma_0_mpa:520, k_mpa:1150, n:0.17, density:7.85, application:'Set screws, Cr-Mo alloy', ht_quench_c:'870–880', ht_temper_c:'≥390', target_hrc:'45–49' },
  'EN8D':   { id:'EN8D',   name:'EN8D (SAE 1045)',  grade:'—',    sigma_0_mpa:350, k_mpa:850,  n:0.22, density:7.85, application:'Heavy hex nuts, B7 stud application', ht_quench_c:'normalise or Q+T', ht_temper_c:'—', target_hrc:'27–32' },
  'A194_2H':{ id:'A194_2H',name:'ASTM A194 Gr 2H',  grade:'—',   sigma_0_mpa:400, k_mpa:920,  n:0.20, density:7.85, application:'High-pressure stud nuts' },
};

// ---- TEMPLATE SELECTION ENGINE ----

export interface PartInput {
  part_type: 'BOLT' | 'NUT';
  nominal_diameter_mm: number;
  thread_pitch_mm: number;
  total_length_mm: number;
  shank_length_mm?: number;
  head_type?: 'HEX_SOCKET' | 'EXTERNAL_HEX' | 'HEX_FLANGE' | 'PLAIN_HEX' | 'COUNTERSUNK' | 'DRAIN_PLUG' | 'NONE';
  socket_type?: 'HEX_SOCKET' | 'NONE';
  has_flange?: boolean;
  has_serration?: boolean;
  has_nylon_insert?: boolean;
  has_conical_washer?: boolean;
  has_socket_feature?: boolean;
  nut_height_mm?: number;
  nut_af_mm?: number;
  wire_diameter_mm?: number;
  blank_length_mm?: number;
  weight_grams?: number;
  material_id?: string;
  standard?: string;
  thread_system?: 'METRIC' | 'INCH';
}

export function selectTemplate(part: PartInput): { template: TemplateId; confidence: number; reasoning: string[] } {
  const reasoning: string[] = [];

  if (part.part_type === 'NUT') {
    if (part.has_nylon_insert) {
      reasoning.push('Nylon insert detected → Template D3 (Nylock)');
      return { template: 'D3', confidence: 0.95, reasoning };
    }
    if (part.has_conical_washer) {
      reasoning.push('Conical washer seat detected → Template D5');
      return { template: 'D5', confidence: 0.95, reasoning };
    }
    if (part.has_socket_feature) {
      reasoning.push('Socket/washer feature detected → Template D6 (Spinning nut)');
      return { template: 'D6', confidence: 0.90, reasoning };
    }
    if (part.standard?.includes('B18.2.2') || part.material_id === 'EN8D') {
      reasoning.push('ASME B18.2.2 or EN8D → Template D4 (Heavy hex nut)');
      return { template: 'D4', confidence: 0.95, reasoning };
    }
    if (part.has_flange && part.has_serration) {
      reasoning.push('Flange + serration → Template D1 (Serrated flange nut)');
      return { template: 'D1', confidence: 0.95, reasoning };
    }
    reasoning.push('Plain hex nut → Template D2');
    return { template: 'D2', confidence: 0.92, reasoning };
  }

  // BOLT
  if (part.head_type === 'NONE' && part.socket_type === 'HEX_SOCKET') {
    reasoning.push('No head, hex socket → Template C (Set screw)');
    return { template: 'C', confidence: 0.98, reasoning };
  }

  const wire = part.wire_diameter_mm ?? part.nominal_diameter_mm * 1.05;
  const blank = part.blank_length_mm ?? part.total_length_mm * 1.02;
  const ld = blank / wire;
  reasoning.push(`L/D = ${ld.toFixed(2)} (blank ${blank.toFixed(1)}mm / wire ${wire.toFixed(1)}mm)`);

  if (ld > 4.0) {
    if (part.head_type === 'EXTERNAL_HEX' && !part.socket_type) {
      reasoning.push('L/D > 4.0, external hex head → Template A-EXT');
      return { template: 'A_EXT', confidence: 0.90, reasoning };
    }
    reasoning.push('L/D > 4.0, has shank → Template A (Long bolt)');
    return { template: 'A', confidence: 0.92, reasoning };
  }

  if (ld < 3.5) {
    if (part.has_serration) {
      reasoning.push('L/D < 3.5, flange + serration → Template B-S');
      return { template: 'B_S', confidence: 0.95, reasoning };
    }
    reasoning.push('L/D < 3.5, flange/plug head → Template B');
    return { template: 'B', confidence: 0.90, reasoning };
  }

  // Borderline 3.5–4.0
  reasoning.push(`L/D ${ld.toFixed(2)} borderline (3.5–4.0) → defaulting to Template A; engineer review recommended`);
  return { template: 'A', confidence: 0.65, reasoning };
}

// ---- MACHINE MATCHING ENGINE ----

export interface MachineMatch {
  machine_id: MachineId;
  machine_name: string;
  eligible: boolean;
  force_utilisation_pct?: number;
  blockers: string[];
  ranking_score: number;
}

export function matchMachines(part: PartInput, template: TemplateId): MachineMatch[] {
  const results: MachineMatch[] = [];
  const isNut = part.part_type === 'NUT';
  const wire = part.wire_diameter_mm ?? part.nominal_diameter_mm * 1.05;
  const blank = part.blank_length_mm ?? part.total_length_mm * 1.02;
  const shank = part.shank_length_mm ?? 0;

  for (const [id, m] of Object.entries(MACHINES)) {
    const blockers: string[] = [];

    // Type filter
    if (isNut && m.type !== 'NUT') { blockers.push('Not a nut former'); }
    if (!isNut && m.type !== 'BOLT') { blockers.push('Not a bolt former'); }

    if (m.type === 'BOLT' && !isNut) {
      if (wire < m.wire_min) blockers.push(`Wire Ø${wire}mm < machine min Ø${m.wire_min}mm`);
      if (wire > m.wire_max) blockers.push(`Wire Ø${wire}mm > machine max Ø${m.wire_max}mm`);
      if (blank > (m.shank_max ?? 999)) blockers.push(`Blank ${blank}mm > machine max ${m.shank_max}mm`);
      if (shank > (m.shank_max ?? 999)) blockers.push(`Shank ${shank}mm > machine max ${m.shank_max}mm`);
      const stationsNeeded = template === 'C' ? 2 : 4;
      if (stationsNeeded > m.stations) blockers.push(`Needs ${stationsNeeded} stations, machine has ${m.stations}`);
    }

    if (m.type === 'NUT' && isNut) {
      const nm = m as any;
      if (wire < m.wire_min) blockers.push(`Wire Ø${wire}mm < min Ø${m.wire_min}mm`);
      if (wire > m.wire_max) blockers.push(`Wire Ø${wire}mm > max Ø${m.wire_max}mm`);
      const af = part.nut_af_mm ?? part.nominal_diameter_mm * 1.7;
      if (af < nm.af_min) blockers.push(`A/F ${af}mm < machine min ${nm.af_min}mm`);
      if (af > nm.af_max) blockers.push(`A/F ${af}mm > machine max ${nm.af_max}mm`);
    }

    // Force estimation (simplified Siebel formula)
    const mat = MATERIALS[part.material_id ?? 'SAE1010'];
    const sigma_f = mat.k_mpa * Math.pow(0.5, mat.n);
    const d_head = part.nominal_diameter_mm * 1.7;
    const h_head = part.nut_height_mm ?? part.nominal_diameter_mm * 0.8;
    const A_head = Math.PI / 4 * d_head * d_head;
    const F_est = sigma_f * A_head * (1 + 0.17 * d_head / h_head) / 9.81 / 1000; // in tonnes
    const F_machine = m.force_kg / 1000;
    const utilisation = F_est / (F_machine * 0.85) * 100;
    if (utilisation > 100) blockers.push(`Est. force ${F_est.toFixed(0)}t > 85% machine capacity ${(F_machine * 0.85).toFixed(0)}t`);

    const eligible = blockers.length === 0;
    const ranking_score = eligible ? (100 - utilisation) + (m.force_kg / 10000) : -1;

    results.push({
      machine_id: id as MachineId,
      machine_name: m.name,
      eligible,
      force_utilisation_pct: utilisation,
      blockers,
      ranking_score,
    });
  }

  return results.sort((a, b) => b.ranking_score - a.ranking_score);
}

// ---- FORGING SEQUENCE GENERATOR ----

export interface StationSpec {
  station: number;
  label: string;
  operation: string;
  die_bore_mm?: number;
  punch_od_mm?: number;
  ko_pin_od_mm?: number;
  ko_type: 'PLAIN' | 'ACTIVE' | 'NONE';
  cone_angle_deg?: number;
  entry_angle_deg?: number;
  tc_pallet?: string;
  pallet_material: 'STEEL' | 'CARBIDE' | 'NONE';
  punch_insert_material: 'D2' | 'M2' | 'M42' | 'TC' | 'H13' | 'NONE';
  notes: string[];
  tool_code?: string;
}

export interface ForgingSequence {
  template: TemplateId;
  machine_id: MachineId;
  part: PartInput;
  wire_diameter_mm: number;
  blank_length_mm: number;
  ld_ratio: number;
  stations: StationSpec[];
  process_flow: string[];
  tool_code_prefix: string;
  warnings: string[];
}

export function generateSequence(part: PartInput, machine_id: MachineId): ForgingSequence {
  const { template, reasoning } = selectTemplate(part);
  const machine = MACHINES[machine_id];
  const warnings: string[] = [];

  const wire = part.wire_diameter_mm ?? part.nominal_diameter_mm * 1.05;
  const blank = part.blank_length_mm ?? part.total_length_mm * 1.02;
  const ld = blank / wire;

  // Volume conservation check
  const mat = MATERIALS[part.material_id ?? 'SAE1010'];
  if (part.weight_grams) {
    const vol_calc = (Math.PI / 4) * wire * wire * blank * mat.density / 1000;
    const diff_pct = Math.abs(vol_calc - part.weight_grams) / part.weight_grams * 100;
    if (diff_pct > 5) warnings.push(`Volume check: calculated ${vol_calc.toFixed(1)}g vs stated ${part.weight_grams}g (${diff_pct.toFixed(1)}% diff — verify wire/blank dims)`);
  }

  // Generate stations based on template
  const stations: StationSpec[] = generateStations(part, template, machine_id, wire, blank, warnings);

  // Process flow
  const process_flow = generateProcessFlow(part, template, machine);

  // Tool code prefix
  const prefix = generateToolCodePrefix(template, machine_id, part);

  return {
    template,
    machine_id,
    part,
    wire_diameter_mm: wire,
    blank_length_mm: blank,
    ld_ratio: ld,
    stations,
    process_flow,
    tool_code_prefix: prefix,
    warnings,
  };
}

function generateStations(part: PartInput, template: TemplateId, machine_id: MachineId, wire: number, blank: number, warnings: string[]): StationSpec[] {
  const d = part.nominal_diameter_mm;
  const machine = MACHINES[machine_id] as any;
  const stations: StationSpec[] = [];

  if (template === 'A' || template === 'A_EXT') {
    const ld = blank / wire;
    const cone_angle = wire >= 11 ? 9 : 6; // Rule: 6° for wire < 11mm, 9° for ≥ 11mm EXCEPT Template B always uses 9°
    if (ld > 12) warnings.push('L/D > 12 — approaching wire buckling limit. Consider 3-stage progressive reduction.');

    stations.push({
      station: 1, label: 'Stn 1 — Cone mark',
      operation: 'Cone marking. Establishes centre for subsequent upsetting.',
      ko_type: 'PLAIN', cone_angle_deg: cone_angle, entry_angle_deg: cone_angle,
      tc_pallet: 'Ø25×50',
      pallet_material: 'CARBIDE', punch_insert_material: 'D2',
      notes: [`${cone_angle}° cone — ${wire >= 11 ? 'wire ≥ 11mm rule' : 'wire < 11mm rule'}`, 'TC pallet Ø25×50 (front guidance)']
    });

    stations.push({
      station: 2, label: 'Stn 2 — Head pre-upset',
      operation: 'Head pre-upset + shank reduction. Top Nib if flange shoulder present.',
      ko_type: 'PLAIN',
      tc_pallet: 'Ø25×50',
      pallet_material: 'CARBIDE', punch_insert_material: 'D2',
      notes: ['10° top cone, R0.8', 'Shank reduces max 12% (Gr10.9) or 18% (Gr5.8)', 'Top Nib insert if flange shoulder present']
    });

    if (template === 'A') {
      const af = d <= 7 ? 'M42' : 'M2';
      stations.push({
        station: 3, label: 'Stn 3 — Hex socket + tail point',
        operation: 'Hex pin punch from punch side + simultaneous tail point from die side.',
        ko_type: 'PLAIN',
        tc_pallet: 'Ø25×40',
        pallet_material: 'CARBIDE', punch_insert_material: af === 'M42' ? 'M42' : 'M2',
        notes: [`Hex punch material: ${af} (A/F ${d <= 7 ? '≤7mm rule: M42' : '>7mm rule: M2'})`, 'Simultaneous tail point (die side)']
      });
    } else {
      stations.push({
        station: 3, label: 'Stn 3 — Coller Hex Trim Die',
        operation: 'External hex formed by Coller Hex Trim Die on punch side. D2 front insert on die side.',
        ko_type: 'PLAIN',
        tc_pallet: 'D2 front insert',
        pallet_material: 'NONE', punch_insert_material: 'D2',
        notes: ['Coller Hex Trim Die — M2 material', '30° entry cone on trim die', 'D2 front die (not TC) — hex body contacts bore exit']
      });
    }

    stations.push({
      station: 4, label: 'Stn 4 — Final trim + finish',
      operation: 'Round Trim Die final flange. Carbide pallet if logo/grade marking required.',
      ko_type: 'PLAIN',
      tc_pallet: part.material_id?.includes('10B') ? 'Carbide Ø35×35 (grade marking)' : 'Steel Ø35×35',
      pallet_material: part.material_id?.includes('10B') ? 'CARBIDE' : 'STEEL',
      punch_insert_material: 'M2',
      notes: ['Round Trim Die — M2', 'Carbide pallet if grade/logo impression required']
    });

  } else if (template === 'B' || template === 'B_S') {
    stations.push({
      station: 1, label: 'Stn 1 — Pre-upset',
      operation: 'Significant head expansion ~25% over wire diameter. 9° cone, 15° top cone, R0.8. Sliding punch mechanism.',
      ko_type: 'PLAIN', cone_angle_deg: 9,
      tc_pallet: 'Ø25×50',
      pallet_material: 'CARBIDE', punch_insert_material: 'D2',
      notes: ['9° cone — Template B always uses 9°', 'Sliding punch: D2 outer sleeve + M2 inner pin', 'Head expands ~25% over wire_dia']
    });

    stations.push({
      station: 2, label: 'Stn 2 — Flange boundary',
      operation: 'Top Nib insert defines head-shank shoulder. 7° entry taper. Head near-final diameter.',
      ko_type: 'PLAIN',
      tc_pallet: 'Ø25×50',
      pallet_material: 'CARBIDE', punch_insert_material: 'D2',
      notes: ['Top Nib insert — H13', '7° entry taper on front die', 'D2 punch insert — 30° approach angle, 3.2–3.6mm depth']
    });

    if (template === 'B_S') {
      stations.push({
        station: 3, label: 'Stn 3 — Hex socket + serration',
        operation: 'Hex socket AND serration formed simultaneously in one stroke. 36 ribs for M10.',
        ko_type: 'PLAIN',
        tc_pallet: 'Steel Ø35×35',
        pallet_material: 'STEEL', punch_insert_material: 'D2',
        notes: [`Serration: ${d <= 10 ? 36 : d <= 14 ? 36 : 48} ribs`, 'D2 punch insert — hex cavity + serration die in same station', '20° hex approach, R20+R0.8 blends']
      });
    } else {
      stations.push({
        station: 3, label: 'Stn 3 — Hex socket formation',
        operation: 'Hex socket fully formed. Steel pallet on punch. Flange near-final A/F.',
        ko_type: 'PLAIN',
        tc_pallet: 'Steel Ø35×35',
        pallet_material: 'STEEL', punch_insert_material: 'D2',
        notes: ['Hex pin punch — M42 if A/F ≤7mm, else M2', 'Flange A/F near-final at this station']
      });
    }

    stations.push({
      station: 4, label: 'Stn 4 — Final trim + dome + marking',
      operation: 'Trim Die on punch side finalises hex. Carbide pallet for dome + logo + grade mark.',
      ko_type: 'PLAIN',
      tc_pallet: 'Carbide Ø35×35',
      pallet_material: 'CARBIDE', punch_insert_material: 'M2',
      notes: ['Trim Die — M2, A/F 16.80–16.95mm range', 'Carbide pallet — dome R10.5 + SFX logo + grade mark', '30° flange chamfer']
    });

  } else if (template === 'C') {
    const hexMat = 'M42'; // Set screws always small A/F
    stations.push({
      station: 1, label: 'Stn 1 — Dual-end simultaneous pre-form',
      operation: 'Punch side: 60°+45° cone creates socket entry cavity. Die side: 45°+60° pre-forms cup/cone point.',
      ko_type: 'NONE',
      pallet_material: 'CARBIDE',
      punch_insert_material: 'M42',
      tc_pallet: `TC Ø${d <= 10 ? '20×40' : '25×40'}`,
      notes: ['Simultaneous dual-end forming', '60°+45° punch side, 45°+60° die side', `TC pallet ${d <= 10 ? 'Ø20×40' : 'Ø25×40'}`, 'Body OD unchanged — only ends deform']
    });

    stations.push({
      station: 2, label: 'Stn 2 — Hex socket + cup point + stripper',
      operation: 'Hex punch finalises socket. Die side finalises cup point. STRIPPER MECHANISM mandatory.',
      ko_type: 'NONE',
      pallet_material: 'CARBIDE',
      punch_insert_material: 'M42',
      tc_pallet: `TC Ø${d <= 10 ? '20×40' : '25×40'}`,
      notes: ['Hex punch material: M42 always (set screw A/F always small)', `Cup point: Ø${(d * 0.7).toFixed(1)}mm ≈ 0.7× nominal`, 'STRIPPER MECHANISM — 8 components mandatory', 'Stripper bush H13, hex punch holder D2, stripper pins M2 × 3 at PCD Ø32mm']
    });

  } else if (template === 'D1' || template === 'D2') {
    // Nut former templates
    const isD1 = template === 'D1';
    const hexStation = isD1 ? 3 : 2; // D1: hex at Stn 3, D2: hex at Stn 2
    const af = part.nut_af_mm ?? d * 1.7;
    const die_height = machine.die_height_mm ?? 25;

    stations.push({
      station: 1, label: 'Stn 1 — Top chamfer + sizing',
      operation: 'Round bore sizing. Top chamfer formation. KO plain rod — ejection only.',
      die_bore_mm: wire + 0.02,
      ko_pin_od_mm: wire - 0.1,
      ko_type: 'PLAIN', entry_angle_deg: 35,
      pallet_material: 'NONE', punch_insert_material: 'M2',
      notes: ['Carbide insert, 35° entry angle', `Die height ${die_height}mm`, '5° OD taper on die', 'KO plain — ejection only']
    });

    stations.push({
      station: 2, label: isD1 ? 'Stn 2 — Pre-upset' : 'Stn 2 — Hex pre-form',
      operation: isD1 ? 'Blank expands in round bore. KO plain.' : `Hex first appears. A/F ≈ ${(af * 0.96).toFixed(2)}mm. KO plain.`,
      die_bore_mm: isD1 ? wire + 0.02 : af * 0.96,
      ko_type: 'PLAIN', entry_angle_deg: isD1 ? 35 : 30,
      pallet_material: 'NONE', punch_insert_material: 'M2',
      notes: [isD1 ? 'Round bore, no hex yet' : 'Hex forms at Stn 2 — D2 template rule', '30° entry angle from Stn 2 onward']
    });

    if (isD1) {
      stations.push({
        station: 3, label: 'Stn 3 — Hex pre-form',
        operation: `Hex first appears at Station 3. A/F ≈ ${(af * 0.96).toFixed(2)}mm.`,
        die_bore_mm: af * 0.96,
        ko_type: 'PLAIN', entry_angle_deg: 30,
        pallet_material: 'NONE', punch_insert_material: 'M2',
        notes: ['Hex appears at Stn 3 — D1 template rule', 'Finger bore transitions to hexagonal shape']
      });
    }

    const stn4 = isD1 ? 4 : 3;
    stations.push({
      station: stn4, label: `Stn ${stn4} — Hex refine + bottom chamfer`,
      operation: 'Hex refined. Active KO pin tip forms bottom chamfer simultaneously with ejection.',
      die_bore_mm: af * 0.98,
      ko_type: 'ACTIVE', entry_angle_deg: 30,
      pallet_material: 'NONE', punch_insert_material: 'M2',
      notes: ['Active KO tip — 45°+15°+8° geometry', 'Forms bottom nut chamfer simultaneously', isD1 ? 'Flange boundary defined' : '']
    });

    const stn5 = isD1 ? 5 : 4;
    const hasSleeve = isD1;
    stations.push({
      station: stn5, label: `Stn ${stn5} — ${isD1 ? 'Sleeve + serration' : 'Final hex form'}`,
      operation: isD1 ? 'SLEEVE PUNCH with serration teeth + nested PIN forms dome. Active KO.' : `Final A/F ${(af - 0.12).toFixed(2)}mm. Active KO finalises chamfer.`,
      die_bore_mm: af - 0.12,
      ko_type: 'ACTIVE', entry_angle_deg: 5,
      pallet_material: 'NONE', punch_insert_material: 'M2',
      notes: [
        `Final die A/F = ${(af - 0.12).toFixed(2)}mm (target ${af}mm, −0.10 to −0.15mm springback allowance)`,
        '5° entry taper only at final station — no cone angle',
        isD1 ? 'Sleeve punch: serration teeth machined into face' : 'Plain hex nut: no sleeve at Station 5',
        'Active KO pins at Stns 4 & 5 universally for nut formers'
      ]
    });

    stations.push({
      station: 6, label: 'Stn 6 — Hole punch (pierce)',
      operation: 'Through-bore pierced. No KO pin — slug falls free. Hole punch bore = minor dia − 0.15mm.',
      ko_type: 'NONE',
      pallet_material: 'NONE', punch_insert_material: 'M2',
      notes: [
        `Hole punch bore ≈ Ø${(d * 0.84 - 0.15).toFixed(2)}mm (minor dia − 0.15mm)`,
        'No KO pin at Station 6 — slug falls free',
        'Hole punch material: M2 always',
        'Tool code uses "9999" batch designator (universal component)'
      ]
    });
  }

  return stations;
}

function generateProcessFlow(part: PartInput, template: TemplateId, machine: any): string[] {
  const mat = MATERIALS[part.material_id ?? 'SAE1010'];
  const steps: string[] = ['Raw Material (wire)'];
  steps.push(`Forging — ${machine.name} (${machine.cbf ?? machine.id}), In House`);

  if (['A','A_EXT','B','B_S'].includes(template)) {
    if (mat.ht_quench_c) {
      steps.push(`Heat Treatment — Q${mat.ht_quench_c}°C, T${mat.ht_temper_c}°C, ${mat.target_hrc} HRC — Outsource furnace`);
    }
    if (part.material_id === 'SCM435') {
      steps.push('Threading — Circular Rolling, In House');
      steps.push('Surface Treatment — Manganese Phosphate + RPO');
    } else {
      steps.push('Surface Treatment');
    }
  } else if (template === 'C') {
    steps.push(`Heat Treatment — Q${mat.ht_quench_c ?? '870–880'}°C, T${mat.ht_temper_c ?? '≥390'}°C, ${mat.target_hrc ?? '45–49'} HRC — Outsource`);
    steps.push('Threading — Circular Rolling, In House');
    steps.push('Surface Treatment — Manganese Phosphate + RPO');
  } else {
    // Nut
    steps.push('Tapping — In House');
    steps.push('Surface Treatment — Zinc / Black / as specified');
  }

  steps.push('Final Inspection');
  steps.push('Dispatch');
  return steps;
}

function generateToolCodePrefix(template: TemplateId, machine_id: MachineId, part: PartInput): string {
  const d = part.nominal_diameter_mm;
  const dStr = d < 10 ? `0${Math.round(d)}` : `${Math.round(d)}`;

  if (machine_id === 'SJBF_134L' || machine_id === 'DBF_134L') {
    if (template === 'A' || template === 'A_EXT') return `134LFBM${dStr}`;
    if (template === 'B' || template === 'B_S') return `134LPGM${dStr}`;
    if (template === 'C') return `134LGSM${dStr}`;
  }
  if (machine_id === 'SJBF_164S') return `164SGSM${dStr}`;
  if (machine_id === 'SN_14B6S') return `14B${Math.round(d*10).toString().padStart(2,'0')}M${dStr}`;
  if (machine_id === 'SN_19B6S') return `19B024011612`;
  if (machine_id === 'SN_24B6S') return `24B024011966`;
  if (machine_id === 'SN_11B6S') return `11BSNM${dStr}`;
  return `FIQ${dStr}`;
}
